import 'css-chunksrc/client/pages/projectPage/resourcesPage/exportButton/styles.scss';export default {
  "exportButton": "_exportButton_i5ft9_1",
  "text": "_text_i5ft9_17",
  "icon": "_icon_i5ft9_21"
};